import React from "react";

export const FirebaseContext = React.createContext();

export const AppContext = React.createContext();
